import { Component, OnInit } from '@angular/core';
import { RazzleDazzleService } from 'src/app/services/RazzleDazzle.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';

@Component({
  selector: 'app-razzle-dazzle',
  templateUrl: './razzle-dazzle.component.html',
  styleUrls: ['./razzle-dazzle.component.css']
})
export class RazzleDazzleComponent implements OnInit {
  razzleDazzleForm: FormGroup;
  emailReg: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  constructor(private serv: RazzleDazzleService, private messageService: MessageService,
  private fb: FormBuilder) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.razzleDazzleForm = this.fb.group({
      Name: [null, Validators.required],
      Department: ['', [Validators.required]],
      Email: [null],
    });
  }
  get f() { return this.razzleDazzleForm.controls; }
  onSubmit() {
;
    if (this.razzleDazzleForm.valid) {
      this.serv.createRazzleDazzleUser(this.razzleDazzleForm.value).subscribe((resp: any) => {
        ;
        if (resp && resp[0].responseCode === '200') {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: resp[0].responseMessage });
          this.resetForm();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Oops', detail: resp[0].responseMessage });
        }
      }, err => {
      });
    }
  }

  resetForm() {
    this.razzleDazzleForm.setValue({
      Name: null,
      Department:'',
      Email:null
    });
    
    const obj = this.f;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key].setErrors(null);
      }
    }
    this.razzleDazzleForm.controls['Name'].setErrors({'Name': true});
    this.razzleDazzleForm.controls['Department'].setErrors({'Department': true});
  }
}
